/**
 * ssrWidth — the wall's remembered container width, so the server justifies the first paint at the
 * reader's real width instead of `SSR_CONTAINER_WIDTH`'s guess (narcis dev, 2026-09-22: a right
 * gutter at 1200, then a snap to 1936 when the JS measured). No request header carries the
 * viewport width in every browser (Safari sends no client hints), hence a cookie the client writes
 * on every measure. Only the document reads it; the cached `/wall` JSON carries no layout.
 * Isomorphic on purpose — the `Cookie` header is parsed by hand so both halves share one file.
 */

export const WALL_WIDTH_COOKIE = 'wall_w'

const MIN_WIDTH = 200
const MAX_WIDTH = 6000

export function readWallWidthCookie(cookieHeader: string | null): number | null {
    if (!cookieHeader) return null
    for (const part of cookieHeader.split(';')) {
        const eq = part.indexOf('=')
        if (eq === -1) continue
        if (part.slice(0, eq).trim() !== WALL_WIDTH_COOKIE) continue
        const n = Number(part.slice(eq + 1).trim())
        return Number.isInteger(n) && n >= MIN_WIDTH && n <= MAX_WIDTH ? n : null
    }
    return null
}

/** Client only. */
export function writeWallWidthCookie(width: number): void {
    if (typeof document === 'undefined') return
    const n = Math.round(width)
    if (n < MIN_WIDTH || n > MAX_WIDTH) return
    document.cookie = `${WALL_WIDTH_COOKIE}=${n}; Path=/; Max-Age=31536000; SameSite=Lax`
}
